import React, { memo, useEffect, useReducer } from "react";
import { observer } from "mobx-react-lite";
import { inject } from "mobx-react";
import { translate } from "react-i18next";
import Constants from "../../../common/Constants";
import CountdownComponent from "../../MainComponent/AccountComponent/AsiaView/MbAsiaMultiFactorAuthenticationComponent/CountdownComponent";
import { Button, Modal } from "react-bootstrap";
import { OTPInput } from "input-otp";
import { isEmpty } from "lodash";
import { LoginStatus, REGEX_VALIDATION } from "../../../common/Foundation";
import AccountAction from "../../../actions/AccountAction";
import { EVENT } from "../../../common/events/listEvents";
import MemberServices from "../../../services/MemberService";

const MbInputOtpComponent = inject("AccountStore")(observer((props) => {
  const { AccountStore, t } = props;
  const { login2FAData, user } = AccountStore
  const { loginId } = user
  const {
    loginId: loginIdFrom2FA,
    otp,
    password,
    mode,
    isShowOtpPopup,
    currentUserOtpType
  } = login2FAData
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      errorOtpCode: '',
      disableUpdateBtn: true,
      userOTPType: ''
    }
  )
  const {
    errorOtpCode,
    disableUpdateBtn,
    userOTPType
  } = state;
  const {
    description,
    inputLabel,
    title,
    textButton,
    descriptionRequireInputOTP,
    bodyAuthenMobileAppDescription,
  } = Constants.MFA_TRANSLATIONS.OTP_CONFIRM;
  const { MODE, STATUS } = Constants.LOGIN_2FA

  useEffect(() => {
    if ((loginId || loginIdFrom2FA) && isEmpty(userOTPType)) {
      // will get and fetch data  from service
      getUserOtpType()
    }
    if (!isEmpty(currentUserOtpType)) {
      setState({ userOTPType: currentUserOtpType })
    }
  }, [loginId, loginIdFrom2FA, userOTPType, currentUserOtpType])

  useEffect(() => {
    window.listenEvent(EVENT.USER_ENABLE_2FA_LOGIN, onListenUserEnable2FA);
    return () => {
      AccountStore.updateLoginData({ isShowOtpPopup: false });
      window.stopListenEvent(EVENT.USER_ENABLE_2FA_LOGIN, onListenUserEnable2FA);
    }
  }, [])
  const getUserOtpType = async () => {
    const res = await AccountAction.getOtpType(loginId || loginIdFrom2FA)
    if (!isEmpty(res)) {
      setState({ userOTPType: res })
    }
  }
  const handleChange = (otpCodeValue) => {
    if (!isEmpty(otpCodeValue)) {
      if (otpCodeValue.length <= 6) {
        AccountStore.updateLoginData({ otp: otpCodeValue });
        setState({
          otpCode: otpCodeValue,
          disableUpdateBtn: otpCodeValue.length < 6,
          errorOtpCode: otpCodeValue.length > 6
        });
      }
    }
  }

  const handleClose = (event) => {
    AccountStore.updateLoginData({
      otp: '',
      isShowOtpPopup: false,
    })
    setState({
      errorOtpCode: false,
    })
    window.fireEvent(EVENT.CANCEL_UPDATE_SETTING)
  }

  const handleSubmitOtpFailed = () => {
    setState({
      otpCode: otp,
      disableUpdateBtn: true,
      errorOtpCode: true,
    });
  }

  const onListenUserEnable2FA = () => {
    AccountStore.updateLoginData({ 
      isShowOtpPopup: true, 
      mode: Constants.LOGIN_2FA.MODE.CHANGE_SETTING,
      loginId: AccountStore.user.loginId,
    });
    AccountStore.updateEnableLoginWith2FA(true);
  }

  const submitLoginWithOTP = async () => {
    try {
      const loginResult = await AccountAction.signin({
        loginId: loginIdFrom2FA,
        password: password,
        otp: otp,
      });
      if (loginResult.status === LoginStatus.INVALID_OTP) {
        handleSubmitOtpFailed();
      }

      if (loginResult.auth) {
        AccountStore.updateLoginData({
          loginWithOtpSuccessfully: true,
          loginResult: loginResult,
          isShowOtpPopup: false 
        });
        setState({ disableUpdateBtn: true })
      }
    } catch (error) {
      handleSubmitOtpFailed();
    }
  }

  const submitChangeSetting = async () => {
    try {
      const payload = {
        enableLoginWith2FA: AccountStore.enableLoginWith2FA,
        showedAnnouncementLoginWith2FA: true,
        otp: otp
      }
      const resChange = await MemberServices.toggleLoginOTP(payload)
      if (resChange.data === STATUS.EMAIL_OTP_INPUT_FAILED) {
        handleSubmitOtpFailed();
      }
      if (resChange.data === STATUS.EMAIL_OTP_INPUT_SUCCESS) {
        window.fireEvent(EVENT.REFRESH_QUICK_FILTER);
        AccountStore.updateUser({ enableLoginWith2FA: AccountStore.enableLoginWith2FA });
        AccountStore.resetLoginData();
        setState({ disableUpdateBtn: true })
      }
    } catch (error) {
      handleSubmitOtpFailed();
    }
  }

  const handleSubmit = async () => {
    if (mode === MODE.LOGIN) {
      await submitLoginWithOTP();
    }
    if (mode === MODE.CHANGE_SETTING) {
      await submitChangeSetting();
    }
  }

  const renderFactorHeader = () => {
    return (
      <div className="multi-header">
        <div className="page-title">
          <p>{t(title)}</p>
        </div>
      </div>
    )
  }

  const renderInputOTP = () => {
    return (
      <React.Fragment>
        <label>{t(inputLabel)}</label>
        <OTPInput
          maxLength={6}
          containerClassName="otp-input-container"
          pushPasswordManagerStrategy="increase-width"
          pattern={REGEX_VALIDATION.regexJustNumber}
          onChange={handleChange}
          render={({ slots }) => (
            <div className="otp-slots">
              {slots.map((slot, idx) => (
                <div
                  key={idx}
                  className={`otp-slot ${slot.isActive ? 'is-active' : ''}`}
                >
                  {slot.char}
                  {slot.hasFakeCaret && <div className="otp-caret" />}
                </div>
              ))}
            </div>
          )}
        />
        {errorOtpCode && <div className={'error-message otp'} dangerouslySetInnerHTML={{ __html: t('Invalid code. Please try again!') }}></div>}
      </React.Fragment>
    )

  }

  const renderOtpInput = () => {
    const resendData = {
      mode: mode,
      loginId: loginIdFrom2FA,
    }
    return (
      <div className="input-container mb-auth-otp">
        <div className="multi-header">
          <div className="copy-right">
            {t(userOTPType === Constants.MFA_CONSTANTS.APP_AUTH
              ? bodyAuthenMobileAppDescription
              : description)}<br /> <br />
            {t(descriptionRequireInputOTP)}
          </div>
        </div>
        {renderInputOTP()}
        {userOTPType === Constants.MFA_CONSTANTS.EMAIL_AUTH
          && <CountdownComponent t={t} disableUpdateBtn={disableUpdateBtn} resendData={resendData}
          />}
      </div>
    )
  }

  const renderSubmitButton = () => {
    return <div className="btn-submit-container">
      <Button
        className='submit-button uppercase btn-update-mfa'
        type="submit"
        disabled={disableUpdateBtn}
        variant="primary"
        onClick={() => handleSubmit()}
      >
        {t(textButton)}
      </Button>
    </div>
  }

  return (
    <React.Fragment>
      <Modal
        className='login-modal-container'
        dialogClassName="login-modal mfa-login login"
        backdropClassName="login"
        show={isShowOtpPopup}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          {renderFactorHeader()}
        </Modal.Header>
        <Modal.Body>
          {renderOtpInput()}
          {renderSubmitButton()}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}));

export default memo(translate()(MbInputOtpComponent));


// WEBPACK FOOTER //
// ./src/app/components/HeaderComponent/MbInputOtpComponent/index.js